import { Zap, Target, TrendingUp, Users, BookOpen, Trophy } from 'lucide-react';

export const testimonials = [
  {
    author: "Rahul Sharma",
    text: "Made $1200 in 2 weeks. Signals are extremely accurate."
  },
  {
    author: "Aman Verma",
    text: "Best trading community I've joined so far."
  },
  {
    author: "Arjun Patel",
    text: "Bot consistency is insane. Profits are stable."
  },
  {
    author: "David Miller",
    text: "Clean signals, no hype, real results."
  },
  {
    author: "Michael Brown",
    text: "Finally something that actually works."
  },
  {
    author: "Sophia Lee",
    text: "Love the structured strategy system."
  },
  {
    author: "Emma Wilson",
    text: "Professional and supportive community."
  },
  {
    author: "Daniel Carter",
    text: "Doubled my account in a month."
  },
  {
    author: "Hassan Ali",
    text: "Perfect for disciplined trading."
  },
  {
    author: "Priya Singh",
    text: "The bot never sleeps. Consistent 24/7 signals."
  }
];

export const benefits = [
  {
    icon: Zap,
    title: "High Accuracy Trading Bot",
    description: "AI-powered Quotex bot delivering consistent signals 24/7"
  },
  {
    icon: Target,
    title: "Live Premium Signals",
    description: "Non-MTG, high-quality signals for sustainable trading"
  },
  {
    icon: TrendingUp,
    title: "Compounding Strategy System",
    description: "Grow small capital like $50 to $5000 with structured plans"
  },
  {
    icon: Trophy,
    title: "Tournament & Challenge System",
    description: "Weekly competitions to maximize discipline and profits"
  },
  {
    icon: BookOpen,
    title: "Educational Content",
    description: "Advanced strategies, videos, and deep market insights"
  },
  {
    icon: Users,
    title: "Community Support",
    description: "Active VIP community with real-time guidance"
  }
];
